<template>
  <el-form ref="deptForm" label-width="100px">
    <el-form-item label="所属图片组">
      <el-select v-model="FileGroupId" filterable placeholder="请选择分组">
        <el-option
          v-for="item in options"
          :key="item.Id"
          :label="item.GroupName"
          :value="item.Id"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="选择图片上传">
      <el-upload
        ref="upload"
        :action="uploadUrl"
        :headers="headers"
        name="files"
        accept="image/jpeg,image/jpg,image/png"
        :multiple="true"
        :limit="20"
        :file-list="fileList"
        :before-upload="beforeUpload"
        :on-success="successUpload"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
      >
        <el-button size="small" type="primary"> 点击上传图片 </el-button>
        <div slot="tip" class="el-upload__tip">
          仅支持 JPG / PNG，且不超过 5MB
        </div>
      </el-upload>
    </el-form-item>

    <el-form-item style="text-align: center">
      <el-button type="primary" @click="handleSure">确定</el-button>
      <el-button @click="handleCancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      uploadUrl: this.$api.UploadFileListV2 + "?module=article",
      headers: {
        Authorization: `Bearer ${this.getCookie("tokenAdmin")}`,
      },
      FileGroupId: "",
      fileList: [],
      addfileList: [],
    };
  },
  methods: {
    handleSure() {
      // 判断是否选择分组
      if (this.FileGroupId == "") {
        this.$message.warning(`请先选择图片分组`);
        return;
      }
      let FileRemoteUrls = [];
      if (this.addfileList.length > 0) {
        this.addfileList.forEach((item) => {
          FileRemoteUrls.push(item.RemoteUrl);
        });
      } else {
        this.$message.warning(`请先上传图片`);
        return;
      }
      this.$post(this.$api.AddFile2Group, {
        FileUrls: FileRemoteUrls,
        FileGroupId: this.FileGroupId,
      })
        .then((res) => {
          if (res.IsSuccess) {
            this.$message.success(res.Message);
            this.handleCancel(); //退出弹窗
          } else {
            this.$message.error(res.Message);
          }
        })
        .catch((err) => {
          this.$message.error("操作失败");
        });
    },

    beforeUpload(file) {
      const isImg = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      const repeat = this.addfileList.some(
        (i) => i.lastModified === file.lastModified && i.name === file.name
      );

      if (!isImg) this.$message.error("仅支持 JPG / PNG");
      if (!isLt5M) this.$message.error("图片不能超过 5MB");
      if (repeat) this.$message.error("该图片已上传");

      return isImg && isLt5M && !repeat;
    },

    successUpload(response, file, fileList) {
      console.log(response, file, fileList);
      let flag = this.addfileList.find((item) => {
        // return (item.name == file.name && item.Id == response.data[0].Id && item.uid == response.data[0].uid)
        return item.RemoteUrl == response.data[0];
      });
      // console.log('file',file)
      if (!flag) {
        this.addfileList.push({
          name: file.name,
          uid: file.uid,
          lastModified: file.raw.lastModified,
          RemoteUrl: response.data[0], //oss地址
        });
      }
      this.fileList = fileList;
    },

    handleRemove(file) {
      // console.log(file, fileList);
      this.addfileList = this.addfileList.filter((item) => {
        return item.uid !== file.uid;
      });
      this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
      // console.log('this.addfileList:', this.addfileList)
    },

    handleExceed(files) {
      this.$message.warning(
        `当前限制选择 20 个文件，本次选择了 ${files.length} 个文件`
      );
    },

    handleCancel() {
      this.FileGroupId = "";
      this.fileList = [];
      this.addfileList = [];
      this.$emit("close");
    },
    getCookie(name) {
      var matches = document.cookie.match(
        new RegExp("(?:^|; )" + name + "=([^;]*)")
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
  },
};
</script>
